import { createContext, useContext, type ReactNode } from 'react';
import type { FestivalEvent, FestivalVenue } from './utils/festivalApi';

export interface CmsContent {
  key: string;
  title: string;
  body: string;
  updated_at: string;
}

export interface CityPageData {
  slug: string;
  name: string;
  venues: FestivalVenue[];
  events: FestivalEvent[];
  cities: string[];
}

export interface PrerenderData {
  cms?: {
    about?: CmsContent | null;
    terms?: CmsContent | null;
    privacy?: CmsContent | null;
  };
  city?: CityPageData;
}

declare global {
  interface Window {
    __KARAOKR_INITIAL_DATA__?: PrerenderData;
  }
}

const PrerenderDataContext = createContext<PrerenderData>({});

export function PrerenderDataProvider({
  children,
  data,
}: {
  children: ReactNode;
  data?: PrerenderData;
}) {
  return (
    <PrerenderDataContext.Provider value={data ?? {}}>
      {children}
    </PrerenderDataContext.Provider>
  );
}

export function usePrerenderData(): PrerenderData {
  return useContext(PrerenderDataContext);
}
